import { motion } from 'framer-motion';
import {
  Home, Grid3X3, Receipt, ClipboardList, Bell, Users,
  FileText, Settings, ChevronRight, ChevronDown, ChevronsLeft, Monitor, MoreVertical, Plus
} from 'lucide-react';

const navItems = [
  { icon: Home, label: 'Home', hasArrow: true },
  { icon: Grid3X3, label: 'Mandatory tariffs', hasArrow: true },
  { icon: Receipt, label: 'Transactions', hasArrow: true },
];

const surveySubItems = ['Survey hub', 'Dashboard'];

const statusTabs = [
  { label: 'All', count: 125, active: true },
  { label: 'Drafts', count: 17 },
  { label: 'In Review', count: 24 },
  { label: 'Rejected', count: 25 },
  { label: 'Approved', count: 28 },
  { label: 'Published', count: 8 },
];

const statusStyles = {
  Published: 'bg-emerald-50 text-emerald-600 border-emerald-200',
  'In review': 'bg-amber-50 text-amber-600 border-amber-200',
  Draft: 'bg-gray-50 text-gray-500 border-gray-200',
  Approved: 'bg-teal-50 text-teal-600 border-teal-200',
  Rejected: 'bg-red-50 text-red-500 border-red-200',
};

const surveys = [
  { name: 'Task assigned', status: 'Published', channel: 'Website', created: "10 Oct' 25", createdTime: '11:00 AM', published: "10 Oct' 25", publishedTime: '12:30 PM', group: 'All' },
  { name: 'Delete role request', status: 'In review', channel: 'Email, SMS', created: "10 Oct' 25", createdTime: '11:00 AM', published: '--', group: 'Provider', others: 3 },
  { name: 'Task assigned', status: 'Draft', channel: 'All', created: "10 Oct' 25", createdTime: '11:00 AM', published: '--', group: 'Payer', others: 2 },
  { name: 'Task assigned', status: 'Published', channel: 'Website', created: "10 Oct' 25", createdTime: '10:00 AM', published: "10 Oct' 25", publishedTime: '11:00 AM', group: 'Payer' },
  { name: 'Task assigned', status: 'Approved', channel: 'Website, Email', created: "10 Oct' 25", createdTime: '11:00 AM', published: '--', group: 'Provider', others: 3 },
  { name: 'Delete role request', status: 'Draft', channel: 'Website', created: "10 Oct' 25", createdTime: '11:00 AM', published: '--', group: 'All' },
  { name: 'Task assigned', status: 'Rejected', channel: 'SMS', created: "10 Oct' 25", createdTime: '11:00 AM', published: '--', group: 'Provider', others: 3 },
  { name: 'Delete role request', status: 'Approved', channel: 'Website, Email', created: "10 Oct' 25", createdTime: '11:00 AM', published: '--', group: 'Provider', others: 3 },
];

export default function SurveyHubScene({ onNext }) {
  return (
    <div data-testid="scene-survey-hub" className="flex items-start justify-center h-full w-full overflow-hidden">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-[1280px] h-[620px] bg-white rounded-2xl border border-black/5 shadow-2xl overflow-hidden flex">
        {/* Sidebar */}
        <motion.aside initial={{ x: -30, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: 0.2 }}
          className="w-[200px] bg-[#FAFAFA] border-r border-[#E5E7EB] flex flex-col flex-shrink-0">
          <div className="px-4 py-4 flex items-center gap-2 border-b border-[#E5E7EB]">
            <div className="w-7 h-7 rounded-md bg-teal-600 flex items-center justify-center"><span className="text-white font-heading font-bold text-[10px]">S</span></div>
            <span className="font-heading font-bold text-sm text-[#0A0A0A]">Shafafiya</span>
          </div>
          <nav className="flex-1 py-2 px-2 space-y-0.5">
            {navItems.map(item => (
              <div key={item.label} className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-[#737373] text-[13px] font-body">
                <item.icon size={16} /><span className="flex-1">{item.label}</span><ChevronRight size={14} className="opacity-40" />
              </div>
            ))}
            {/* Survey - active */}
            <div className="flex items-center gap-2.5 px-3 py-2 rounded-lg bg-teal-600 text-white text-[13px] font-body font-medium">
              <ClipboardList size={16} /><span className="flex-1">Survey</span><ChevronDown size={14} />
            </div>
            <div className="ml-4 mt-1 space-y-0.5">
              {surveySubItems.map((s, i) => (
                <div key={s} className={`px-3 py-1.5 rounded-lg text-[13px] font-body ${i === 0 ? 'text-teal-700 font-medium bg-teal-50' : 'text-[#737373]'}`}>{s}</div>
              ))}
            </div>
            <div className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-[#737373] text-[13px] font-body"><Bell size={16} /><span className="flex-1">Notification engine</span><ChevronRight size={14} className="opacity-40" /></div>
            <div className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-[#737373] text-[13px] font-body"><Users size={16} /><span className="flex-1">Manage</span><ChevronRight size={14} className="opacity-40" /></div>
            <div className="flex items-center gap-2.5 px-3 py-2 rounded-lg text-[#737373] text-[13px] font-body"><FileText size={16} /><span className="flex-1">Resources</span><ChevronRight size={14} className="opacity-40" /></div>
          </nav>
          <div className="border-t border-[#E5E7EB] px-2 py-2 space-y-1">
            <div className="flex items-center gap-2 px-3 py-1.5 text-[12px] font-body text-[#737373]"><ChevronsLeft size={14} /><span>Collapse menu</span></div>
            <div className="flex items-center gap-2 px-3 py-1.5 text-[13px] font-body text-[#737373]"><Settings size={16} /><span>Settings</span></div>
            <div className="flex items-center gap-2.5 px-3 py-2">
              <div className="w-8 h-8 rounded-full bg-orange-400 flex items-center justify-center flex-shrink-0"><span className="text-white text-[10px] font-bold">OS</span></div>
              <div><p className="text-[12px] font-body font-medium text-[#0A0A0A]">Omar Saba</p><p className="text-[10px] font-body text-[#737373]">m@example.com</p></div>
            </div>
          </div>
        </motion.aside>

        {/* Main */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <div className="flex items-center justify-end px-6 py-3 border-b border-[#E5E7EB]">
            <div className="flex items-center gap-3"><Bell size={18} className="text-[#737373]" /><div className="flex items-center gap-2 text-[13px] font-body text-[#737373]"><Monitor size={16} /><span>عربي</span></div></div>
          </div>

          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} className="px-6 pt-5 pb-3">
            <div className="flex items-start justify-between">
              <div><h1 className="font-heading font-bold text-2xl text-[#0A0A0A]">Survey Hub</h1><p className="font-body text-sm text-[#737373] mt-1">Create and manage surveys across their lifecycle</p></div>
              <button onClick={onNext} className="flex items-center gap-1.5 px-4 py-2.5 rounded-lg bg-teal-600 text-white text-sm font-body font-medium cursor-pointer"><Plus size={16} /> Create new survey</button>
            </div>
            <div className="flex items-center gap-2 mt-4">
              {statusTabs.map((tab, i) => (
                <motion.button key={tab.label} initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 + i * 0.06 }}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[13px] font-body ${tab.active ? 'bg-[#0A0A0A] text-white' : 'text-[#737373]'}`}>
                  {tab.label} <span className={`text-[11px] px-1.5 py-0.5 rounded-full ${tab.active ? 'bg-white/20' : 'bg-[#E5E7EB]'}`}>{tab.count}</span>
                </motion.button>
              ))}
            </div>
          </motion.div>

          <div className="flex-1 overflow-y-auto px-6">
            <table className="w-full">
              <thead><tr className="border-b border-[#E5E7EB]">
                {['Notification name', 'Status', 'Channel', 'Created', 'Published', 'User groups', ''].map(h => (
                  <th key={h} className="text-left py-2.5 text-[12px] font-body font-medium text-[#737373]">{h && <span className="flex items-center gap-1">{h} <span className="text-[10px] opacity-40">&#x25B4;&#x25BE;</span></span>}</th>
                ))}
              </tr></thead>
              <tbody>
                {surveys.map((s, i) => (
                  <motion.tr key={i} initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 + i * 0.05 }} className="border-b border-[#F5F5F5]">
                    <td className="py-2.5 text-[13px] font-body font-medium text-[#0A0A0A]">{s.name}</td>
                    <td className="py-2.5"><span className={`px-2.5 py-0.5 rounded-full text-[11px] font-medium border ${statusStyles[s.status]}`}>{s.status}</span></td>
                    <td className="py-2.5 text-[13px] font-body text-[#737373]">{s.channel}</td>
                    <td className="py-2.5"><p className="text-[13px] font-body text-[#737373]">{s.created}</p><p className="text-[11px] font-body text-[#737373]/60">{s.createdTime}</p></td>
                    <td className="py-2.5"><p className="text-[13px] font-body text-[#737373]">{s.published}</p>{s.publishedTime && <p className="text-[11px] font-body text-[#737373]/60">{s.publishedTime}</p>}</td>
                    <td className="py-2.5 text-[13px] font-body text-[#737373]">{s.group}{s.others && <span className="text-teal-600 text-[11px] ml-1">+{s.others} others</span>}</td>
                    <td className="py-2.5"><MoreVertical size={14} className="text-[#737373]" /></td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex items-center justify-between px-6 py-3 border-t border-[#E5E7EB]">
            <span className="text-[12px] font-body text-[#737373]">Page 1 of 10</span>
            <div className="flex items-center gap-1">
              <button className="px-2.5 py-1 text-[12px] font-body text-[#737373]">&lt; Previous</button>
              <button className="w-7 h-7 rounded-md bg-[#0A0A0A] text-white text-[12px] font-body font-medium">1</button>
              <button className="w-7 h-7 rounded-md text-[12px] font-body text-[#737373]">2</button>
              <button className="w-7 h-7 rounded-md text-[12px] font-body text-[#737373]">3</button>
              <span className="text-[12px] text-[#737373]">...</span>
              <button className="px-2.5 py-1 text-[12px] font-body text-[#737373]">Next &gt;</button>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
